import { Pipe, PipeTransform } from '@angular/core';
import { Duration } from 'luxon';

@Pipe({
  name: 'msToTime'
})
export class MsToTimePipe implements PipeTransform {

  transform(ms: number): any {
    const hh = Math.floor(Duration.fromMillis(ms).as('hours')).toString().padStart(2, '0');
    const mm = Math.floor(Duration.fromMillis(ms).as('minutes') % 60).toString().padStart(2, '0');
    const ss = Math.floor(Duration.fromMillis(ms).as('seconds') % 60).toString().padStart(2, '0');
    return `${hh}:${mm}:${ss}`;
  }

}
